



























































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { ErrorHelper } from 'core-helpers';
import { parseQueue } from '@/common/helpers/parseQueue';
// import ws from '../../common/ws/ws';
import { User } from '@/models/User';
import { GetterTypes as UserGetterTypes } from '@/store/user/types';
import SlotsGroup from '@/models/SlotsGroup';
import ConfirmDialogComponent from '../ConfirmDialog/ConfirmDialog.vue';
import Queue from '../../models/Queue';
// import WsSlotResponse from '../../models/WsSlotReponse';
import Slot from '../../models/Slot';
import Message from '../../models/Message';
import QueuesService from '../../services/QueuesService';
import UserService from '../../services/UserService';
import SlotList from '../SlotList/SlotList.vue';
import queueImg from '../../assets/queue.svg';
import slotsImg from '../../assets/add-slots.svg';

import {
  ActionTypes as ActionTypesQueue,
  FetchSlotsForQueueData,
  GetterTypes as GetterTypesQueue,
  MutationTypes as MutationTypesQueue
} from '../../store/queues/types';
import { ActionTypes as ActionTypesSnackbar } from '../../store/snackbar/types';

import './QueueList.scss';

const queueNamespace: string = 'queue';
const snackbarNamespace: string = 'snackbar';
const userNamespace: string = 'user';

@Component({ components: { ConfirmDialogComponent, SlotList } })
export default class QueueList extends Vue {
  // @Prop({ type: Object, required: true }) queue!: Queue | undefined;
  @Prop({ default: false }) adminView!: boolean;

  @Ref('dialogRef') readonly dialogComponent!: ConfirmDialogComponent;

  @Action(ActionTypesSnackbar.SHOW, { namespace: snackbarNamespace }) showSnackbar!: (message: Message) => void;
  @Action(ActionTypesQueue.FETCH_SLOTS_FOR_QUEUE, { namespace: queueNamespace }) fetchQueueSlots!: (
    payload: FetchSlotsForQueueData
  ) => Promise<void>;
  @Action(ActionTypesQueue.ENROLL_TO_SLOT, { namespace: queueNamespace }) enrollToSlot!: (
    payload: string
  ) => Promise<void>;
  @Getter(GetterTypesQueue.GET_SELECTED_QUEUE_UUID, { namespace: queueNamespace }) queueUuid!: string;
  @Getter(GetterTypesQueue.GET_QUEUE, { namespace: queueNamespace }) queue!: Queue;
  @Mutation(MutationTypesQueue.SET_QUEUE, { namespace: queueNamespace }) setQueue!: (queue: Queue) => void;
  @Action(ActionTypesQueue.FETCH_USER_QUEUES, { namespace: queueNamespace }) fetchUserQueues!: (
    user: User
  ) => Promise<void>;
  @Getter(UserGetterTypes.GET_LOGGED_USER, { namespace: userNamespace }) loggedUser!: User | null;
  @Getter(GetterTypesQueue.GET_IS_LOADING, { namespace: queueNamespace }) isQueueActionLoading!: boolean;

  private isSignUpForVisitLoading: boolean = false;

  private selectedDay: string = '';
  private isPanelExpansed: boolean = false;

  private focusOnElement: HTMLElement | null = null;
  private selectedSlot: string = '';

  private queuesService: QueuesService = new QueuesService();
  private userService: UserService = new UserService();

  get errorImg(): any {
    return queueImg;
  }

  get addSlotsImg(): any {
    return slotsImg;
  }

  private beforeDestroy(): void {
    this.leaveFromQueueChannels();
  }

  private async signUpForVisit(): Promise<void> {
    this.isSignUpForVisitLoading = true;

    try {
      await this.enrollToSlot(this.selectedSlot);

      if (this.queue) {
        if (this.queue && this.queue.days) {
          this.queue.days.forEach((group: SlotsGroup) => {
            group.slots.map((slot: Slot) => {
              if (slot.uuid === this.selectedSlot) {
                slot.isOccupied = true;
              }
              return slot;
            });
          });
        }

        if (this.loggedUser) {
          await this.fetchUserQueues(this.loggedUser);
        }
      }

      this.showSnackbar({ message: this.$tc('notification.enroll-to-slot-success'), color: 'success' });
    } catch (err: unknown) {
      const error = ErrorHelper.getAxiosError(err);

      if (error) {
        const { status } = error;

        if (status === 500) {
          this.showSnackbar({ message: 'Wystąpił nieznany błąd!', color: 'error' });
        } else if (status === 403) {
          this.showSnackbar({ message: 'Brak uprawnień', color: 'error' });
        } else {
          this.showSnackbar({ message: error.data.data[0], color: 'error' });
        }
      }
    } finally {
      this.isSignUpForVisitLoading = false;
      this.dialogComponent.close();
    }
  }

  private updateQueue(uuid: string, flagIsOccupied: boolean): void {
    if (this.queue) {
      this.queue.slots.map((item: Slot) => {
        if (item.uuid === uuid) {
          item.isOccupied = flagIsOccupied;
        }

        return item;
      });

      const parsedQueue = parseQueue(this.queue);
      this.setQueue(parsedQueue);

      this.$forceUpdate();
    }
  }

  private connectToQueueChannels(): void {
    // if (this.queue?.uuid) {
    //   try {
    //     ws.channel(`queue.${this.queue.uuid}`)
    //       .listen('.slot-freed', (data: WsSlotResponse) => {
    //         const { uuid } = data.slot;
    //
    //         if (this.queue) {
    //           const isSlotExists = this.queue.slots.some((slot: Slot) => slot.uuid === uuid);
    //           if (!isSlotExists) {
    //             this.queue.slots.push(data.slot);
    //           }
    //           this.updateQueue(uuid, false);
    //         }
    //       })
    //       .listen('.slot-occupied', (data: WsSlotResponse) => {
    //         const { uuid }: { uuid: string } = data.slot;
    //
    //         if (uuid) {
    //           this.updateQueue(uuid, true);
    //         }
    //       });
    //   } catch (err: unknown) {
    //     console.error('PUSHER ERR', err);
    //   }
    // }
  }

  private leaveFromQueueChannels(): void {
    // ws.leaveChannel(`queue.${this.queue.uuid}`);
  }

  private makeExpansionPanelWCAG(id: string) {
    if (this.selectedDay === id && this.isPanelExpansed) {
      this.isPanelExpansed = false;

      return;
    }

    this.selectedDay = id;
    this.isPanelExpansed = !this.isPanelExpansed;

    const ul: HTMLElement | null = document.querySelector(`[id="${id}"]`);

    if (ul) {
      const firstElementInList = ul.children[0] as HTMLElement;

      setTimeout(() => {
        firstElementInList.focus();
      }, 200);
    }
  }

  private openDialog(uuid: string): void {
    this.focusOnElement = document.querySelector(`[id="${uuid}"]`);

    this.dialogComponent.show();
    this.selectedSlot = uuid;
  }

  private closeDialog(): void {
    this.selectedSlot = '';
  }

  private onDeleteSlotEvent(slotUuid: string): void {
    this.$emit('delete-slot', slotUuid);
  }

  @Watch('queueUuid', { deep: true })
  private async onQueueUuidChange(): Promise<void> {
    this.leaveFromQueueChannels();

    try {
      if (this.queueUuid) {
        await this.fetchQueueSlots({ queueUuid: this.queueUuid, scope: this.adminView ? 1 : 0 });
      }
      this.connectToQueueChannels();
    } catch (err: unknown) {
      if (process.env.APP_DEBUG === true) {
        console.error(err);
      }
    }
  }
}
